export default class extends HTMLElement {
  connectedCallback () {
    this.inputEl = document.getElementById(this.dataset.inputId)
    this.buttons = [...this.querySelectorAll('[data-action="click:folder-browser#open"]')]

    // Add manual click handler for every open trigger (input, change-folder link)
    this.buttons.forEach((button) => button.addEventListener('click', this.open))
  }

  disconnectedCallback () {
    this.buttons.forEach((button) => button.removeEventListener('click', this.open))
  }

  open = (e) => {
    e?.preventDefault()
    this.createModal()
    this.loadFolders()
  }

  createModal () {
    this.modal = document.createElement('div')
    this.modal.className = 'modal modal-open items-start !animate-none overflow-y-auto'
    this.modal.innerHTML = `
      <div class="modal-backdrop absolute top-0 bottom-0 right-0 left-0"></div>
      <div class="modal-box pt-4 pb-6 px-6 mt-20 max-h-none w-full max-w-2xl">
        <div class="flex justify-between items-center border-b pb-2 mb-4 font-medium">
          <span>${this.dataset.title || 'Select Folder'}</span>
          <a href="#" class="modal-close-btn text-xl">&times;</a>
        </div>
        <div class="mb-4">
          <input type="text" placeholder="${this.dataset.searchPlaceholder || 'Filter folders...'}"
                 class="filter-input base-input w-full" autocomplete="off">
        </div>
        <div class="folder-grid grid grid-cols-2 sm:grid-cols-3 gap-3 max-h-80 overflow-y-auto" style="min-height: 200px;">
          <div class="col-span-full text-center py-8 text-base-content/60">Loading...</div>
        </div>
      </div>
    `

    // Add event listeners for modal elements
    this.modal.querySelector('.modal-backdrop').addEventListener('click', this.close)
    this.modal.querySelector('.modal-close-btn').addEventListener('click', this.close)
    this.modal.querySelector('.filter-input').addEventListener('input', this.filter)

    document.body.appendChild(this.modal)
    document.body.classList.add('overflow-hidden')

    this.modal.querySelector('.filter-input').focus()

    document.addEventListener('keyup', this.onEscKey)
  }

  onEscKey = (e) => {
    if (e.code === 'Escape') {
      this.close()
    }
  }

  close = (e) => {
    e?.preventDefault()

    if (this.modal) {
      this.modal.remove()
      this.modal = null
    }

    document.body.classList.remove('overflow-hidden')
    document.removeEventListener('keyup', this.onEscKey)
  }

  async loadFolders () {
    try {
      const resp = await fetch('/template_folders_autocomplete?q=')
      this.folders = await resp.json()
      this.renderFolders(this.folders)
    } catch (error) {
      this.renderError()
    }
  }

  filter = (e) => {
    const query = e.target.value.toLowerCase().trim()

    if (!this.folders) return

    if (!query) {
      this.renderFolders(this.folders)
      return
    }

    const filtered = this.folders.filter(folder =>
      folder.full_name.toLowerCase().includes(query) ||
      folder.name.toLowerCase().includes(query)
    )

    this.renderFolders(filtered)
  }

  renderFolders (folders) {
    const grid = this.modal?.querySelector('.folder-grid')
    if (!grid) return

    // Use a Map to deduplicate by full_name (which includes parent path)
    const uniqueFolders = new Map()
    folders.forEach(folder => {
      const key = folder.full_name || folder.name
      if (!uniqueFolders.has(key)) {
        uniqueFolders.set(key, folder)
      }
    })

    const uniqueList = Array.from(uniqueFolders.values())

    if (uniqueList.length === 0) {
      grid.innerHTML = `<div class="col-span-full text-center py-8 text-base-content/60">${this.dataset.emptyText || 'No folders found'}</div>`
      return
    }

    grid.innerHTML = uniqueList.map(folder => `
      <button type="button"
              class="folder-item flex flex-col justify-between rounded-xl py-4 px-4 w-full bg-base-200 hover:bg-base-300 transition-colors text-left cursor-pointer border-2 border-transparent hover:border-primary min-h-[80px]"
              data-folder-name="${this.escapeHtml(folder.full_name || folder.name)}"
              data-folder-id="${folder.id}">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mb-2" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"/>
        </svg>
        <span class="text-sm font-medium line-clamp-2" style="overflow: hidden; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2;">
          ${this.escapeHtml(folder.full_name || folder.name)}
        </span>
      </button>
    `).join('')

    // Add click handlers to all folder items
    grid.querySelectorAll('.folder-item').forEach(btn => {
      btn.addEventListener('click', this.select)
    })
  }

  renderError () {
    const grid = this.modal?.querySelector('.folder-grid')
    if (!grid) return

    grid.innerHTML = `<div class="col-span-full text-center py-8 text-error">Failed to load folders</div>`
  }

  select = (e) => {
    e.preventDefault()

    const folderName = e.currentTarget.dataset.folderName
    const folderId = e.currentTarget.dataset.folderId

    if (this.inputEl) {
      this.inputEl.value = folderName
      this.inputEl.dispatchEvent(new Event('change', { bubbles: true }))
    }

    if (this.dataset.idInputId) {
      const idInput = document.getElementById(this.dataset.idInputId)

      if (idInput) {
        idInput.value = folderId
        idInput.dispatchEvent(new Event('change', { bubbles: true }))
      }
    }

    this.close()
  }

  escapeHtml (text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
